export default __webpack_public_path__ + "static/media/fare-logo-only.9d4a8805.svg";